import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PartnerErrorModal.scss';

interface PartnerErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
}

const PartnerErrorModal: React.FC<PartnerErrorModalProps> = ({
  isOpen,
  onClose,
  message
}) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  const handleBackToPartners = () => {
    onClose();
    navigate('/flight-ranges/admin/partners');
  };

  const handleManageFlightRanges = () => {
    onClose();
    navigate('/flight-ranges/admin');
  };

  return (
    <div 
      className="partner-error-modal-backdrop" 
      onClick={handleBackdropClick}
      onKeyDown={handleKeyDown}
      role="dialog"
      aria-modal="true"
      aria-labelledby="partner-error-modal-title"
      aria-describedby="partner-error-modal-description"
    >
      <div className="partner-error-modal">
        <button
          className="partner-error-modal__close-button"
          onClick={onClose}
          aria-label="Close modal"
          type="button"
        >
          ×
        </button>
        <div className="partner-error-modal__header">
          <h2 id="partner-error-modal-title" className="partner-error-modal__title">
            Remaining flight ranges.
          </h2>
        </div>
        
        <div className="partner-error-modal__body">
          <p id="partner-error-modal-description" className="partner-error-modal__message">
            {message}
          </p>
        </div>
        
        <div className="partner-error-modal__footer">
          <div className="partner-error-modal__footer-buttons">
            <button
              className="partner-error-modal__back-button"
              onClick={handleBackToPartners}
              type="button"
            >
              Back to partners
            </button>
            <button
              className="partner-error-modal__manage-button"
              onClick={handleManageFlightRanges}
              type="button"
              autoFocus
            >
              Manage flight ranges
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerErrorModal;